<template>
  <div class="center-warp">
    <div style="width: 834px;background: #ffffff">
      <div class="big-case-header d-flex-between">
        <div class="add-btn" @click="goChat" style="margin-top: 10px">进入对话</div>
        <div class="d-flex" style="align-items: center;margin-top: 10px">
          <div class="del-btn" v-if="isPizu" @click="isPizu = false">取消批注</div>
          <div class="add-btn" @click="saveNote">{{ isPizu ? '保存批注' : '批注模式' }}</div>
        </div>

      </div>

      <div class="big-case-outer-scroll">
        <div class="big-case-outer" ref="bigCase">
          <img v-if="!isPizu" :src="caseDetail.big_case_pizhu_img"  class="big-case-pizhu">
          <div v-for="item in  caseCardList">
            <div class="card-top">
              {{ item.type_name }} {{ item.card_date }}
              <div class="add-btn" @click="openOtherData(item.id)">查看其它资料</div>
            </div>
            <div v-if="item.type_id != 5" class="d-flex-between">
              <div class="case-detail-img">
                <div class="detail-img-3-l">
                  <el-image
                    :preview-src-list="[item.cemian_pic]"
                    :src="item.cemian_pic">
                    <div slot="error" class="image-slot">
                      <img :src="defaultImg" alt="">
                    </div>
                  </el-image>
                  <el-image
                    :preview-src-list="[item.zhengmian_pic]"
                    :src="item.zhengmian_pic">
                    <div slot="error" class="image-slot">
                      <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                    </div>
                  </el-image>
                  <el-image
                    :preview-src-list="[item.zhengmian_weixiao_pic]"
                    :src="item.zhengmian_weixiao_pic">
                    <div slot="error" class="image-slot">
                      <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                    </div>
                  </el-image>
                </div>
                <div class="detail-img-3-s">
                  <el-image
                    :preview-src-list="[item.youce_yaohe_pic]"
                    :src="item.youce_yaohe_pic">
                    <div slot="error" class="image-slot">
                      <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                    </div>
                  </el-image>
                  <el-image
                    :preview-src-list="[item.zhengwei_yaohe_pic]"
                    :src="item.zhengwei_yaohe_pic">
                    <div slot="error" class="image-slot">
                      <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                    </div>
                  </el-image>
                  <el-image
                    :preview-src-list="[item.zuoce_yaohe_pic]"
                    :src="item.zuoce_yaohe_pic">
                    <div slot="error" class="image-slot">
                      <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                    </div>
                  </el-image>
                </div>
                <div class="detail-img-1">
                  <el-image
                    :preview-src-list="[item.quanjing_pic]"
                    :src="item.quanjing_pic">
                    <div slot="error" class="image-slot">
                      <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                    </div>
                  </el-image>
                </div>
                <div class="detail-img-1-2">
                  <el-image
                    :preview-src-list="[item.ceweimian_x_pic]"
                    :src="item.ceweimian_x_pic">
                    <div slot="error" class="image-slot">
                      <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                    </div>
                  </el-image>
                  <div class="detail-img-1-2-right">
                    <el-image
                      :preview-src-list="[item.shanglingyalie_pic]"
                      :src="item.shanglingyalie_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                    <el-image
                      :preview-src-list="[item.xialingyalie_pic]"
                      :src="item.xialingyalie_pic">
                      <div slot="error" class="image-slot">
                        <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                      </div>
                    </el-image>
                  </div>
                </div>
                <div class="detail-img-3-s">
                  <el-image
                    :preview-src-list="[item.fuhe_fugai_pic]"
                    :src="item.fuhe_fugai_pic">
                    <div slot="error" class="image-slot">
                      <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                    </div>
                  </el-image>
                  <el-image
                    :preview-src-list="[item.zhengmian_kaikou_zhao]"
                    :src="item.zhengmian_kaikou_zhao">
                    <div slot="error" class="image-slot">
                      <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                    </div>
                  </el-image>
                  <el-image
                    :preview-src-list="[item.zhengmian_yangshi_pic]"
                    :src="item.zhengmian_yangshi_pic">
                    <div slot="error" class="image-slot">
                      <img :src="require('@/assets/img/base/grey-logo.png')" alt="">
                    </div>
                  </el-image>
                </div>
              </div>
              <div class="case-detail-txt">
                <div class="case-detail-info">
                  <div class="case-detail-info-line">
                    <div class="case-info-name">姓名</div>
                    <div class="case-info-cont">{{ item.patient.name }}</div>
                  </div>
                  <div class="case-detail-info-line">
                    <div class="case-info-name">病例年龄</div>
                    <div class="case-info-cont">{{ item.patient.age_text }}</div>
                  </div>
                  <div class="case-detail-info-line">
                    <div class="case-info-name">首诊主诉</div>
                    <div class="case-info-cont" style="width: 100%">{{ item.patient.case_info }}</div>
                  </div>
                  <div v-if="item.type_id == 2 || item.type_id == 3" class="case-detail-info-line">
                    <div class="case-info-name">{{ item.type_id == 2 ? '复诊' : '会诊' }}情况</div>
                    <div class="case-info-cont" style="width: 100%">{{ item.being_treatment }}</div>
                  </div>
                  <div class="case-detail-info-line">
                    <div class="case-info-name">
                      {{ item.patient.confirm_first_case_type_text ? '确认' : '期望' }}套餐类型
                    </div>
                    <div class="case-info-cont" style="width: 100%">{{
                        item.patient.confirm_first_case_type_text ? item.patient.confirm_first_case_type_text : item.patient.first_case_type_name
                      }}
                    </div>
                  </div>
                </div>
                <div class="case-detail-info">
                  <div class="case-detail-info-title d-flex-between">
                    <div class="case-info-cont">病历记录</div>
                  </div>
                  <div class="ill-part">
                    <div class="case-info-name">难度标记</div>
                    <el-dropdown style="width: 100%" trigger="click">
                      <div class=" d-flex-between ill-grey-bg">
                        <div class="ill-dropdown"><span
                          v-if="item.difficulty_level">{{ item.difficulty_level }}级</span></div>
                        <div class="iconfont icon-youjiantou"></div>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in writeCode.app_patient_difficulty_level" :command="item.name">
                          {{ item.name }}级
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <div class="ill-part" v-if="item.type_id != 2 && item.type_id != 3">
                    <div class="case-info-name">首诊牙列期</div>
                    <div class="ill-grey-bg d-flex-between">
                      <div v-for="item in writeCode.yalieqi" class="black-14">{{ item.name }}</div>
                    </div>
                  </div>
                  <div class="ill-part" v-if="item.type_id != 2 && item.type_id != 3">
                    <div class="case-info-name">首诊牙列替换完成时间</div>
                    <div class="ill-grey-bg d-flex-between">
                      <div v-for="item in writeCode.yalietihuanwanchengshijian"
                           :class="item.yalie_tihuan_finish_time == item.name ? 'ill-on' : ''"
                           class="black-14">{{ item.name }}
                      </div>
                    </div>
                  </div>
                  <div class="ill-part" v-if="item.type_id != 2 && item.type_id != 3">
                    <div class="case-info-name">首诊牙列拥挤度</div>
                    <div class="small-grey-line d-flex-between">
                      <div class="black-14">上颌</div>
                      <div class="ill-grey-bg d-flex-between">
                        <div v-for="item in writeCode.shangheyalieyongjidu"
                             :class="item.shanghe_yalie_yongji_rate == item.name ? 'ill-on' : ''"
                             class="black-14">{{
                            item.name
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="small-grey-line d-flex-between">
                      <div class="black-14">下颌</div>
                      <div class="ill-grey-bg d-flex-between">
                        <div v-for="item in writeCode.xiaheyalieyongjidu"
                             :class="item.xiahe_yalie_yongji_rate == item.name ? 'ill-on' : ''"
                             class="black-14">{{ item.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ill-part">
                    <div class="case-info-name">侧貌面型</div>
                    <div class="ill-grey-bg d-flex-between">
                      <div v-for="item in writeCode.cemaomianxing"
                           :class="item.cemao_mianxing == item.name ? 'ill-on' : ''"
                           class="black-14">{{ item.name }}
                      </div>
                    </div>
                  </div>
                  <div class="ill-part" v-if="item.type_id != 2 && item.type_id != 3">
                    <div class="case-info-name">生长评估期</div>
                    <img alt="" src="../../assets/img/case_management/cs-table.png"
                         style="width: 100%;margin-bottom: 10px">
                    <el-dropdown style="width: 100%" trigger="click">
                      <div class=" d-flex-between ill-grey-bg">
                        <div class="ill-dropdown">
                          {{
                            item.shengzhangqi_pinggu ? item.shengzhangqi_pinggu : writeCode.shengzhangqipinggu[0].name
                          }}
                        </div>
                        <div class="iconfont icon-youjiantou"></div>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in writeCode.shengzhangqipinggu" :command="item.name">
                          {{ item.name }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <div class="ill-part">
                    <div class="case-info-name">龋齿</div>
                    <div class="ill-grey-bg d-flex-between">
                      <div v-for="item in writeCode.quchi" :class="item.quchi == item.name ? 'ill-on' : ''"
                           class="black-14">{{ item.name }}
                      </div>
                    </div>
                  </div>
                  <div class="ill-part">
                    <div class="case-info-name">诊疗建议</div>
                    <textarea v-model="item.treat_proposal"
                              class="black-14 ill-grey-textarea"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="big-case">
              <div class="d-flex-center sheji-package">
                <div>{{item.patient.confirm_first_case_type ? '确认套餐类型：' : '期望套餐类型：'}}</div>
                <div class="case-person-cycle package-tag" :class="item.patient.confirm_first_case_type != null ? '' : 'case-person-cycle-grey'">{{item.patient.confirm_first_case_type_text != '' ? item.patient.confirm_first_case_type_text :item.patient.first_case_type_name}}</div>
              </div>
              <img class="sheji-img1" :src="item.shejidan_img" alt="">
              <img class="sheji-img2" :src="item.pizhu_img" alt="">
            </div>
          </div>
          <Zwibbler v-if="isPizu" :dataInfo1="pizhu_img" ref="zwibbler" :width="width" :height="height"></Zwibbler>
        </div>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="showCaseCardDetail"
        custom-class="page-dialog"
        width="834px">
        <div class="case-card-detail">
          <div class="case-card-detail-right">
            <div class="case-card-detailtitle d-flex-between">
              <div>其他资料</div>
              <div class="add-btn case-card-btn" @click="showCaseCardDetail = false">返回</div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">补充视频资料</div>
              <div class="case-upload-line">
                <template v-if="otherCardData.other_media_json && otherCardData.other_media_json.media" >
                  <div v-for="item in otherCardData.other_media_json.media" class="upload-video-item">
                    <video controls :src="item.url" :poster="item.fm_img"></video>
                    <div>MP4</div>
                  </div>
                </template>
              </div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">补充文件资料</div>
              <div class="case-upload-line">
                <template v-if="otherCardData.other_media_json && otherCardData.other_media_json.file" >
                  <div v-for="item in otherCardData.other_media_json.file" class="upload-file-item" @click="openUrl(item.url)">
                    <div class="upload-file-item-icon">
                      <img alt="" src="../../assets/img/case_management/upload-file.png">
                    </div>
                    <div class="upload-file-item-name limit-2">{{ item.title }}</div>
                  </div>
                </template>
              </div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">智贝云分析报告</div>
<!--              <div class="case-upload-line">-->
<!--                <div v-for="i in 2" class="upload-file-item">-->
<!--                  <div class="upload-file-item-icon">-->
<!--                    <img alt="" src="../../assets/img/case_management/upload-report.png">-->
<!--                  </div>-->
<!--                  <div class="upload-file-item-name limit-1">侧位片分析</div>-->
<!--                  <div class="upload-file-item-time">2023.09.26</div>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {CreateCaseCard, GetCardList, GetCaseInfo, GetListByTypeCode, GetOtherInfo, SaveBigCasePizhu2} from "@/http/api";
import Zwibbler from '@/components/Zwibbler'
import ossUpload from "@/http/ossUpload";
import {compressionImage, dataURLtoFile, fileProcess, getBase64Image} from "@/assets/js/imgHandle";
export default {
  name: "big_case",
  components:{Zwibbler},
  data() {
    return {
      caseCardList: '',
      caseId: this.$route.query.id,
      writeCode: {},
      defaultImg:require('@/assets/img/base/grey-logo.png'),
      showCaseCardDetail:false,
      otherCardData:{},
      member:JSON.parse(localStorage.getItem("member")),
      caseDetail:{},
      width:0,
      height:0,
      isPizu:false,
      pizhu_img:''
    }
  },
  mounted() {
    this.$store.commit('breadChange', {name: '大病案', isBack: false})
    GetListByTypeCode({type_code: ['app_patient_difficulty_level', 'yalieqi', 'yalietihuanwanchengshijian', 'shangheyalieyongjidu', 'xiaheyalieyongjidu', 'cemaomianxing', 'shengzhangqipinggu', 'quchi']})
      .then(res => {
        this.writeCode = res.data
      })
    this.initCaseCardData('load')
    this.initCase()


  },
  methods: {
    initCase(){
      GetCaseInfo({id:this.caseId}).then(res=>{
        this.caseDetail = res.data
      })
    },
    initCaseCardData(type) {
      this.caseCardList = []
      this.cardloadStatus = 'load'
      GetCardList({patient_id: this.caseId, type_id: [1, 2, 3, 4, 5], pageSize: 999}).then(res => {
        this.caseCardList = res.data.data
        if(type == 'load'){
          this.$nextTick(()=>{
            this.width = this.$refs.bigCase.clientWidth
            this.height = this.$refs.bigCase.clientHeight
            console.log(this.height)
          })

        }
      })
    },
    openOtherData(id){
      this.showCaseCardDetail = true
      this.initCardOtherData(id)
    },
    initCardOtherData(id){
      GetOtherInfo({card_id:id}).then(res=>{
        this.otherCardData = res.data
      })
    },
    goChat(){
      this.$router.push({
        name: '会话框',
        query: {
          case_id: this.caseId,
          card_id: this.caseCardList[0].id
        }
      })
    },
    saveNote(){
      console.log(this.isPizu)
      if(this.isPizu){
        let blob = this.$refs.zwibbler.saveTu()
        ossUpload.bucketUpload(blob, (res) => {
          SaveBigCasePizhu2({patient_id:this.caseId,big_case_pizhu_img:res.url}).then(res=>{
            if(res.code == 200){
              this.$message({
                type:'success',
                message:'保存成功'
              })
              this.isPizu = false
              this.initCase()
            }else{
              this.$message({
                type:'error',
                message:res.message[0]
              })
            }
          })
        }, (err) => {
          this.$message({
            type: "error",
            message: '上传失败'
          })
        }, 'duole-images', '/upload/image/pc/big_case_pizhu/')
      }else{
        if(this.caseDetail.big_case_pizhu_img){
          fileProcess(this.caseDetail.big_case_pizhu_img,new Date().getTime() + '.png').then(fileList=>{
            compressionImage(fileList.raw,this.width,this.height).then(fileRes => {
              ossUpload.bucketUpload(fileRes, (res) => {
                this.pizhu_img = res.url
                this.isPizu = true
              }, (err) => {
                this.$message({
                  type: "error",
                  message: '批注图片加载失败'
                })
              }, 'duole-images', '/upload/image/pc/temp/')
            })
          })
        }else{
          this.isPizu = true
        }
      }
    }
  }
}
</script>

<style scoped src="../../assets/css/case_management.css"></style>
<style>
.page-dialog, .page-dialog .el-dialog__header, .page-dialog .el-dialog__body {
  padding: 0;
  background: transparent;
  box-shadow: none;
}
.case-detail-img img {
  -o-object-fit: contain;
  object-fit: contain;
  border: 1px dashed lightgrey;
}
</style>
